export default "__VITE_ASSET__Bm0_uFdW__"